import type { NewsItem, NewsLangBlock } from '../data/goldNews';
import type { MarketNewsItem } from '../services/marketDataApi';

export const marketNewsSlug = (id: number | string) => `market-news-${id}`;

const toBlock = (item: MarketNewsItem): NewsLangBlock => {
  const summary = String(item.snippet || item.title || '').trim();

  return {
    title: String(item.title || '').trim(),
    summary,
    content: summary,
  };
};

export function marketNewsToNewsItem(
  item: MarketNewsItem,
  language: keyof NewsItem['lang'],
): NewsItem {
  const block = toBlock(item);
  const emptyBlock: NewsLangBlock = { ...block };
  const tags = String(item.symbols || '')
    .split(',')
    .map((symbol) => symbol.trim())
    .filter(Boolean);

  const lang: NewsItem['lang'] = {
    'zh-HK': { ...emptyBlock },
    'zh-CN': { ...emptyBlock },
    en: { ...emptyBlock },
  };
  lang[language] = block;

  return {
    id: `partner-news-${item.id}`,
    slug: marketNewsSlug(item.id),
    category: 'markets',
    source: item.site || 'Partner News',
    sourceUrl: item.url || undefined,
    publishedAt: item.publishedAtUtc || item.publishedAt,
    image: item.imageUrl || undefined,
    tags: tags.length > 0 ? tags : [item.type || 'Market News'],
    lang,
  };
}
